module.exports = __webpack_public_path__ + "media/images/display/closed-chat-c25259efd23cd4b6f62d1c064f9077fe.svg";